// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureCards_container__238U1"};